export interface LoginResponse {
  access_token: string;
}

export interface AccessTokenClaims {
  exp: number;
  user_id: string;
  username: string;
  user_full_name: string;
  roles: string[];
}

/** Navigation state that makes the login page show `message`, e.g. after the session expired. */
export interface LoginPageState {
  message: string;
}

export const AUTH_TOKEN_STORAGE_KEY = 'romulus-partner-token';
export const PASSWORD_MIN_LENGTH = 8;
export const OTP_LENGTH = 6;

export enum AUTH_ERROR_CODE {
  OTP_INVALID = 'OTP_INVALID',
}
